import WarningIcon from "PFIcons/warning.svg";
import React from "react";

import { ProfileRowErrors } from "../types";
import css from "../workforce.module.scss";

type ErrorsCellProps = {
  errors: ProfileRowErrors;
  profileId: number;
};

export const ErrorsCell = ({ errors, profileId }: ErrorsCellProps) => {
  const cellError = errors[profileId];

  if (!cellError) {
    return null;
  }

  return (
    <span className={css.errorCell}>
      <WarningIcon width={20} height={20} />
      {cellError}
    </span>
  );
};
